var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseroctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/useroctagon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.325 6.09367L14.1375 2.52075C13.1271 1.93742 11.8771 1.93742 10.8562 2.52075L4.67915 6.09367C4.181 6.3825 3.76763 6.79733 3.48056 7.2965C3.19349 7.79567 3.04284 8.36159 3.04374 8.93742V16.0624C3.04374 17.2291 3.66874 18.3124 4.67915 18.9062L10.8667 22.4791C11.8771 23.0624 13.1271 23.0624 14.1479 22.4791L20.3354 18.9062C20.8336 18.6173 21.2469 18.2025 21.534 17.7033C21.8211 17.2042 21.9717 16.6382 21.9708 16.0624V8.93742C21.9663 8.36146 21.8122 7.79655 21.5237 7.29805C21.2352 6.79954 20.8221 6.38453 20.325 6.09367ZM12.5021 7.64575C13.8458 7.64575 14.9292 8.72909 14.9292 10.0728C14.9292 11.4166 13.8458 12.4999 12.5021 12.4999C11.1583 12.4999 10.075 11.4166 10.075 10.0728C10.075 8.7395 11.1583 7.64575 12.5021 7.64575ZM15.2937 17.3541H9.7104C8.86665 17.3541 8.37707 16.4166 8.84582 15.7187C9.55415 14.6666 10.9292 13.9583 12.5021 13.9583C14.075 13.9583 15.45 14.6666 16.1583 15.7187C16.6271 16.4062 16.1271 17.3541 15.2937 17.3541Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseroctagon);
export default __webpack_public_path__ + "static/media/useroctagon.54236af0b92c7f6b9ce53f33e005f5cf.svg";
export { ForwardRef as ReactComponent };